const MenuList = {
  options: {
    data: {},
    customization: {
      items: {
        type: 'TreeList',
        order: 1,
      },
      textSize: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 2,
      },
      childTextSize: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 3,
      },
      textColor: {
        type: 'HexColor',
        order: 4,
      },
      showAllTextSize: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 2,
      },
      showAllTextColor: {
        type: 'HexColor',
        order: 4,
      },
      showAllTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 7,
      },
      childTextColor: {
        type: 'HexColor',
        order: 5,
      },
      borderColor: {
        type: 'HexColor',
        order: 6,
      },
      textWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 7,
      },
      imageTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 8,
      },

      gap: {
        type: 'RangePx',
        data: {
          max: 30,
          min: 0,
          step: 1,
        },
        order: 10,
      },
      backgroundSize: {
        type: 'Radio',
        order: 11,
        data: {
          direction: 'row',
          radioOptions: ['cover', 'stretch'],
        },
      },
      borderRadius: {
        data: {
          max: 30,
          min: 0,
          step: 1,
          svgType: 'border',
        },
        type: 'FourPx',
        order: 12,
      },
      boxShadow: {
        type: 'ChildComponentRenderer',
        order: 13,
        data: {
          componentNames: ['shadow1', 'shadow2', 'shadow3'],
        },
      },
      childsBorderRadius: {
        data: {
          max: 30,
          min: 0,
          step: 1,
          svgType: 'border',
        },
        type: 'FourPx',
        order: 13,
      },
      childsTextWeight: {
        type: 'SelectBox',
        data: {
          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        },
        order: 14,
      },
      showAllButton: {
        type: 'Radio',
        order: 15,
        data: {
          direction: 'row',
          radioOptions: ['show', 'notShow'],
        },
      },
    },
    widgets: {
      ToggleRadioTabs_1: {
        type: 'ToggleRadioTabs',
        order: 11,
        renderOptions: {
          direction: 'row',
          controlKey: 'backgroundType',
        },
        options: {
          backgroundImage: {
            type: 'ImageUploader',
          },
          backgroundColor: {
            type: 'HexColor',
          },
        },
      },
      'widget.Tabs_1': {
        type: 'Tabs',
        order: 9,
        options: {
          containerPadding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
          },
          padding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
          },
        },
      },
      Menu_LevelOneSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'LevelOneSettings',
        },
        options: {
          levelOneTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          levelOneTextColor: {
            type: 'HexColor',
            order: 1,
          },
          levelOneTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
        },
      },
      Menu_LevelTwoSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'LevelTwoSettings',
        },
        options: {
          levelTwoTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          levelTwoTextColor: {
            type: 'HexColor',
            order: 1,
          },
          levelTwoTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
        },
      },
      Menu_LevelThreeSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'LevelThreeSettings',
        },
        options: {
          levelThreeTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          levelThreeTextColor: {
            type: 'HexColor',
            order: 1,
          },
          levelThreeTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
        },
      },
      Menu_LevelFourAndOthersSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'LevelFourAndOtherSettings',
        },
        options: {
          levelFourAndOthersTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          levelFourAndOthersTextColor: {
            type: 'HexColor',
            order: 1,
          },
          levelFourAndOthersTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'MenuList_1',
      name: 'MenuList_1',
      type: 'MenuList',
      data: {
        images: [],
      },
      customization: {
        textSize: '20px',
        childTextSize: '10px',
        textColor: '#000000',
        childTextColor: '#000000',
        textWeight: '400',
        imageTextWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '4px 4px 4px 4px',
        gap: '4px',
        items: [],
        borderColor: '#C1A7FF',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        canUpdatedWithoutImage: true,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://mobligo-bucket.s3.eu-central-1.amazonaws.com/MenuList_1.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'MenuList_2',
      name: 'MenuList_2',
      type: 'MenuList',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '20px',
        textColor: '#000000',
        textWeight: '400',
        imageTextWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '4px 4px 4px 4px',
        items: [],
        borderColor: '#C1A7FF',
        padding: '4px 4px 4px 4px',
        levelOneTextSize: '14px',
        levelOneTextColor: '#000000',
        levelOneTextWeight: '400',
        levelTwoTextSize: '14px',
        levelTwoTextColor: '#000000',
        levelTwoTextWeight: '400',
        levelThreeTextSize: '14px',
        levelThreeTextColor: '#000000',
        levelThreeTextWeight: '400',
        levelFourAndOthersTextSize: '14px',
        levelFourAndOthersTextColor: '#000000',
        levelFourAndOthersTextWeight: '400',
        showAllTextSize: '14px',
        showAllTextColor: '#9e9e9e',
        showAllTextWeight: '400',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        canUpdatedWithoutImage: true,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/collectionList_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'MenuList_3',
      name: 'MenuList_3',
      type: 'MenuList',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '20px',
        childTextSize: '10px',
        textColor: '#000000',
        childTextColor: '#000000',
        textWeight: '400',
        imageTextWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '4px 4px 4px 4px',
        gap: '4px',
        items: [],
        borderColor: '#C1A7FF',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://mobligo-bucket.s3.eu-central-1.amazonaws.com/collection_list_3.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'MenuList_5',
      name: 'MenuList_5',
      type: 'MenuList',
      data: {
        text: '',
        images: [],
      },
      customization: {
        imageTextWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '4px 4px 4px 4px',
        items: [],
        borderColor: '#C1A7FF',
        padding: '4px 4px 4px 4px',
        levelOneTextSize: '14px',
        levelOneTextColor: '#000000',
        levelOneTextWeight: '400',
        levelTwoTextSize: '14px',
        levelTwoTextColor: '#000000',
        levelTwoTextWeight: '400',
        levelThreeTextSize: '14px',
        levelThreeTextColor: '#000000',
        levelThreeTextWeight: '400',
        levelFourAndOthersTextSize: '14px',
        levelFourAndOthersTextColor: '#000000',
        levelFourAndOthersTextWeight: '400',
        showAllTextSize: '14px',
        showAllTextColor: '#9e9e9e',
        showAllTextWeight: '400',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/collectionList_5.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'MenuList_6',
      name: 'MenuList_6',
      type: 'MenuList',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '14px',
        childTextSize: '12px',
        textColor: '#000000',
        childTextColor: '#000000',
        textWeight: '500',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '0px 0px 0px 0px',
        items: [],
        borderColor: '#C1A7FF',
        backgroundSize: 'cover',
        borderRadius: '10px 10px 10px 10px',
        childsBorderRadius: '30px 30px 30px 30px',
        childsTextWeight: '400',
        showAllButton: 'show',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        canUpdatedWithoutImage: true,
        isForcedImage: true,
        maximumIndent: 1,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/MenuList_6.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'MenuList_7',
      name: 'MenuList_7',
      type: 'MenuList',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '20px',
        textColor: '#000000',
        textWeight: '400',
        imageTextWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '15px 15px 15px 15px',
        items: [],
        borderColor: '#F6F6F6',
        padding: '7px 7px 7px 7px',
        levelOneTextSize: '14px',
        levelOneTextColor: '#000000',
        levelOneTextWeight: '400',
        levelTwoTextSize: '14px',
        levelTwoTextColor: '#000000',
        levelTwoTextWeight: '400',
        levelThreeTextSize: '14px',
        levelThreeTextColor: '#000000',
        levelThreeTextWeight: '400',
        levelFourAndOthersTextSize: '14px',
        levelFourAndOthersTextColor: '#000000',
        levelFourAndOthersTextWeight: '400',
        showAllTextSize: '14px',
        showAllTextColor: '#979797',
        showAllTextWeight: '400',
        borderRadius: '10px 10px 10px 10px',
        boxShadow: 'shadow3',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        canUpdatedWithoutImage: true,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/collectionList_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'MenuList_8',
      name: 'MenuList_8',
      type: 'MenuList',
      data: {
        text: '',
        images: [],
      },
      customization: {
        textSize: '20px',
        textColor: '#000000',
        textWeight: '400',
        imageTextWeight: '400',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        backgroundType: '-',
        containerPadding: '15px 15px 15px 15px',
        items: [],
        borderColor: '#F6F6F6',
        padding: '7px 7px 7px 7px',
        levelOneTextSize: '14px',
        levelOneTextColor: '#000000',
        levelOneTextWeight: '400',
        levelTwoTextSize: '14px',
        levelTwoTextColor: '#000000',
        levelTwoTextWeight: '400',
        levelThreeTextSize: '14px',
        levelThreeTextColor: '#000000',
        levelThreeTextWeight: '400',
        levelFourAndOthersTextSize: '14px',
        levelFourAndOthersTextColor: '#000000',
        levelFourAndOthersTextWeight: '400',
        showAllTextSize: '14px',
        showAllTextColor: '#979797',
        showAllTextWeight: '400',
        borderRadius: '10px 10px 10px 10px',
        boxShadow: 'shadow3',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 1,
        maxImage: 1,
        modulo: 1,
        canUpdatedWithoutImage: true,
        renderTabs: {
          category: 'default',
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/collectionList_1.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};

export default MenuList;
